export default {
  isLoading: false,
  assignedCompanies: [],
  assignedCompaniesPageSize: 10,
  updateAssignedCompanies: false,
  allCompanies: [],
  allCompaniesPageSize: 10,
  updateAllCompanies: false,
  selectedCompanies: [],
  isOpenModalAgregar: false,
  isOpenModalEliminar: false,
};

